import { useContext, useEffect, useMemo, useState } from "react"
import { ToastContext } from "../../../context/ToastContext";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import { callautopopulate } from "../../../services/callautopop";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const useClientHighlight = () => {

    const { showSuccess, showInfo, showError } = useContext(ToastContext);
    const [showPopup, setShowPopup] = useState({
        show: false,
        type: "create"
    });
    const [option, setOption] = useState({});
    const [formValue, setformValue] = useState({});
    const [rowData, setRowData] = useState([]);
    const [confirmationPopup, setConfirmationPopup] = useState({
        show: false,
        data: null,
        showDelete: false
    });
    const [loader, setLoader] = useState(false)

    useEffect(() => {
        callautopopulate("users", "project_category", "user_info").then(async res => {
            setOption({ userOption: res?.users, clientOption: res?.project_category });
            getUserClientData(res?.user_info[0]?.user_code)
        })

    }, [])

    const activeTemplate = (rowData) => {
        return (
            <input
                type="checkbox"
                checked={rowData.is_active === undefined ? true : rowData.is_active}
                onChange={() =>
                    setConfirmationPopup({
                        show: true,
                        data: rowData,
                        is_active: rowData.is_active ? false : true,
                    })
                }
            />
        );
    };

    const deleteTemplate = (rowData) => {
        return (
            <FontAwesomeIcon
                icon="fa-solid fa-trash"
                className="remove"
                onClick={() =>
                    setConfirmationPopup({ showDelete: true, id: rowData.history_id })
                }
            />
        );
    };

    const AddUserWithClient = async (key, action) => {

        try {
            if (!key && !formValue?.users) {
                showInfo("info", "Please select user.");
                return;
            } else if (!key && !formValue?.clients) {
                showInfo("info", "Please select Cilent.");
                return;
            }
            let result = []
            if (key) {
                result.push({
                    requested_user_code: key.user_code,
                    client_id: key.client_id,
                    is_active: action
                })
            } else {
                result = formValue?.users?.flatMap(user =>
                    formValue?.clients.map(client => ({
                        requested_user_code: user.user_code,
                        client_id: client.client_id,
                        is_active: true
                    }))
                )
            }
            const payload = {
                client_user_mapping: result
            }
            const res = await services.getInvokeRemote("POST", Urls("ADDCLIENTSUSERS"), payload);
            if (res?.body?.error_status === false) {
                showSuccess("success", res?.body?.message)
                setformValue({});
                setConfirmationPopup({})
                getUserClientData()
            } else {
                showError("error", res?.body?.errorMessage)
            }
        } catch (error) {
            console.error("error", error);
            showError("Error", error?.response?.data?.errorMessage);
        }
    }

    const removeClientUser = async (id) => {
        try {
            const payload = {
                history_id: id
            }
            const res = await services.getInvokeRemote("POST", Urls("REMOVEPROJECTCLIENTUSERS"), payload);
            if (res?.body?.error_status === false) {
                showSuccess("success", res?.body?.message)
                setConfirmationPopup({});
                getUserClientData();
            } else {
                showError("error", res?.body?.errorMessage)
            }

        } catch (error) {
            console.error("error", error);
            showError("Error", error?.response?.data?.errorMessage);
        }
    }


    const getUserClientData = async (id) => {
        try {
            setLoader(true)
            const payload = {
                "requested_user_code": id || 0
            }
            const res = await services.getInvokeRemote("POST", Urls("GETCLIENTSUSERS"), payload)
            if (res?.body?.error_status === false) {
                setRowData(res?.body?.data?.users_data)
            }
            setLoader(false)
        } catch (error) {
            setLoader(false)
            console.error("error", error);
            showError("Error", error?.response?.data?.errorMessage);
        }
    }

    return useMemo(() => ({
        showPopup, setShowPopup, option, formValue, setformValue, AddUserWithClient, rowData, confirmationPopup, setConfirmationPopup, removeClientUser, activeTemplate, deleteTemplate, loader
    }), [showPopup, setShowPopup, option, formValue, setformValue, AddUserWithClient, rowData, confirmationPopup, setConfirmationPopup, removeClientUser, activeTemplate, deleteTemplate, loader])
}